import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// ../~/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 869
// module chunks = 121